import { createTheme, ThemeProvider } from '@mui/material/styles';

const HAPPYKACY = createTheme({
    palette: {
      primary: {
        main: '#4db6ac', // Use the actual color value
      },
      secondary: {
        main: '#80cbc4', // Use the actual color value
      },
      background: {
        default: '#b2dfdb', // Use the actual color value
      },
      text: {
        primary: '#005357', // Use the actual color value
      },
    },
    // other theme customizations
  });
  export default HAPPYKACY;